import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { DsButtonModule, DsIconModule, DsTooltipDirectiveModule } from '@bmw-ds/components';

import { useI18n } from '../../../../../i18n/services/i18n.service';
import { SearchResultMode } from '../../model/search-result-mode.model';

@Component({
  selector: 'cdf-no-search-results',
  imports: [DsIconModule, DsButtonModule, DsTooltipDirectiveModule],
  template: `
    <ds-icon icon="search" />
    <h3>{{ i18n('searchResults.noSearchResultsFound') }}</h3>
    <span class="title-s text-neutral">{{ i18n('tryAgainOr') }}</span>
    <ds-button
      (click)="createNewCustomer.emit()"
      [disabled]="readonly()"
      [ds-tooltip]="i18n('readonlyTooltip')"
      [dsTooltipConfig]="{ disabled: !readonly(), origin: 'bottom', showTriggerDelay: 500 }"
      >{{ buttonText() }}</ds-button
    >
  `,
  styleUrl: './no-search-results.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NoSearchResultsComponent {
  protected readonly i18n = useI18n();

  readonly searchResultMode = input<SearchResultMode>(SearchResultMode.CUSTOMER_SEARCH);
  readonly readonly = input(false);

  readonly createNewCustomer = output();

  protected readonly buttonText = computed(() =>
    this.searchResultMode() === SearchResultMode.MERGE_WITH_NSC
      ? this.i18n('nscSync.createNewNscCustomer')
      : this.i18n('searchResults.createNewCustomerButtonWhenNotFound'),
  );
}
